import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3" aria-label="I Say I Am home">
            <img
              src="/isayiam-app-icon.png"
              alt=""
              className="h-10 w-10 rounded-xl shadow-sm"
            />
            <span className={`text-2xl font-semibold tracking-tight transition-colors ${
              isScrolled ? 'text-[#2C2C2C]' : 'text-[#2C2C2C]'
            }`}>
              I Say I Am
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#features" className="text-[#5A5A5A] hover:text-[#2C2C2C] transition-colors text-sm font-medium whitespace-nowrap cursor-pointer">
              Features
            </a>
            <a href="#products" className="text-[#5A5A5A] hover:text-[#2C2C2C] transition-colors text-sm font-medium whitespace-nowrap cursor-pointer">
              Products
            </a>
            <a href="#testimonials" className="text-[#5A5A5A] hover:text-[#2C2C2C] transition-colors text-sm font-medium whitespace-nowrap cursor-pointer">
              Testimonials
            </a>
            <a href="#faq" className="text-[#5A5A5A] hover:text-[#2C2C2C] transition-colors text-sm font-medium whitespace-nowrap cursor-pointer">
              FAQ
            </a>
            <a href="#download" className="px-6 py-2.5 bg-[#2C2C2C] text-white rounded-full text-sm font-medium hover:bg-[#1a1a1a] transition-all hover:shadow-lg whitespace-nowrap cursor-pointer">
              Get the App
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-[#2C2C2C]`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-6 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <a href="#features" onClick={() => setIsMobileMenuOpen(false)} className="text-[#5A5A5A] hover:text-[#2C2C2C] transition-colors text-sm font-medium cursor-pointer">
                Features
              </a>
              <a href="#products" onClick={() => setIsMobileMenuOpen(false)} className="text-[#5A5A5A] hover:text-[#2C2C2C] transition-colors text-sm font-medium cursor-pointer">
                Products
              </a>
              <a href="#testimonials" onClick={() => setIsMobileMenuOpen(false)} className="text-[#5A5A5A] hover:text-[#2C2C2C] transition-colors text-sm font-medium cursor-pointer">
                Testimonials
              </a>
              <a href="#faq" onClick={() => setIsMobileMenuOpen(false)} className="text-[#5A5A5A] hover:text-[#2C2C2C] transition-colors text-sm font-medium cursor-pointer">
                FAQ
              </a>
              <a href="#download" onClick={() => setIsMobileMenuOpen(false)} className="px-6 py-2.5 bg-[#2C2C2C] text-white rounded-full text-sm font-medium hover:bg-[#1a1a1a] transition-all whitespace-nowrap cursor-pointer w-full text-center">
                Get the App
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
